import { log } from '@shared/log.browser.ts';
import { isSponsoredProduct } from '@shared/types/types';
import type { EventsOutgoing } from '@tilelist/application/ports/EventsOutgoing.ts';
import { type TileListItem, isProductItem } from '@tilelist/domain/composition/TileListitem.ts';

const MAX_ITEMS_TO_TRACK = 5;

export function trackFirebase(eventsOutgoing: EventsOutgoing, tileListItems: TileListItem[]) {
    const productItemsToTrack = tileListItems
        .filter(isProductItem)
        .filter(({ product }) => !isSponsoredProduct(product))
        .slice(0, MAX_ITEMS_TO_TRACK);

    for (const productItem of productItemsToTrack) {
        const item_id = productItem.product.articleNumber ?? 'UNKNOWN';

        log.debug(
            `Firebase Tracking: item_id:${item_id}, localListPosition: ${productItem.localListPosition}, productType: ${productItem.product.productType}`,
        );
        eventsOutgoing.trackProductView(item_id);
    }
}
